<template>
  <commona :data="config"></commona>
</template>
<script>
import commona from "./commona.vue";
export default {
  components: { commona },
  data() {
    return {
      config: {
        title: '加油费用',
        urlKey: '/refuel',
        formId: 'jiayou',
        item: {
          carId: 0,
          carNo: "",
          refuelCost: 0,
          refuelDate: Date.now(),
          cardNo: "",
          mileage: 0,
          proofList: [],
          refuelStation: "",
          refuelVolume: 0,
          remainVolume: 0,
          remark: "",
          type: "",
          unitPrice: 0,
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pay/carOil.vue